<template>
  <div class="container-fluid">
    <b-card no-body class="my-2">
      <b-card-header class="">
        <b-card-title class="card-title-page-garden-help-default my-1">Add Job
        </b-card-title>
      </b-card-header>
    </b-card>

    <b-form @submit.prevent="onSubmit" ref="addJobForm">
      <b-card no-body class="mt-4">
        <b-card-body class="px-2">
          <b-row>
            <b-col md="6" class="pr-md-0">
              <PersonalData v-if="user_type != 'user'" :type="perosnal_data_type" :view_select_customer="true"
                :first_name.sync="first_name" :invalid_first_name="invalid_first_name" :last_name.sync="last_name"
                :invalid_last_name="invalid_last_name" :email.sync="email" :invalid_email="invalid_email"
                :invalid_correct_email="invalid_correct_email" :phone_number.sync="phone_number"
                :invalid_phone_number="invalid_phone_number" :contact_through.sync="contact_through"
                :selected_customer_id.sync="selected_customer_id" :customer_list="customer_list"
                :invalid_customer_id="invalid_customer_id" :country_code="country_code" />

              <PropertyDetails :type="property_data_type" :address.sync="address" :longitude.sync="longitude"
                :latitude.sync="latitude" :invalid_address="invalid_address"
                :invalid_address_longitude="invalid_address_longitude"
                :invalid_address_latitude="invalid_address_latitude" :country.sync="country" :county.sync="county"
                :city.sync="city" :property_type.sync="property_type" :invalid_property_type="invalid_property_type"
                :property_size="property_size" :site_details.sync="site_details" :property_images.sync="property_images"
                :invalid_images="invalid_images" :selected_property_id.sync="selected_property_id"
                :property_list="property_list" :invalid_property_id="invalid_property_id"
                :selected_property_images="selected_property_images" :country_code="country_code" />

              <ServiceDetails type="add" :service.sync="service" :service_options="service_options"
                :invalid_service="invalid_service" :first_time_service.sync="first_time_service"
                :last_service_date.sync="last_service_date" :booking_date.sync="booking_date"
                :invalid_booking_date="invalid_booking_date" :short_description.sync="short_description"
                :more_details.sync="more_details" />

              <!-- {{ service }}
                <hr/>
                {{ service_options }} -->

              <b-card no-body class="card-transparent-background my-0" v-if="user_type == 'operator'">

                <b-card-body class="py-0 pr-0">
                  <div class="">
                    <b-row>
                      <b-col sm="12">
                        <InputRadio :field_label="'Assign to me'" :field_model.sync="assign_to_me"
                          :options="yes_no_options" name="assign_to_me" :is_invalid="invalid_assign_to_me"
                          :invalid_message="' Please select one option'" />
                      </b-col>
                    </b-row>
                    <b-row v-if="assign_to_me == '0' && is_company == 1">
                      <b-col sm="12">
                        <b-form-group class="form-group-garden-help form-group-property-gh" label="Select staff member"
                          label-for="selected_property_id" label-class="form-label-garden-help">
                          <p v-if="invalid_staff_id" class="error_validation_message_p_gardenhelp">
                            Please select staff member
                          </p>
                          <v-select :options="staff_list" v-model="staff_id" name="staff_id" :value="staff_id"
                            title="staff_id" placeholder="Select " label="name" :reduce="(item) => item.id"
                            :clearable="false" :searchable="true" required>
                          </v-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <!-- {{ assign_to_me }} ,,, {{ staff_id }} -->
                  </div>
                </b-card-body>
              </b-card>

            </b-col>
            <b-col md="6">
              <b-card no-body class="card-transparent-background h-100 my-0">
                <b-card-header class="card-title-garden-help-default pb-0 pl-1">Select Location on Map</b-card-header>
                <b-card-body class="h-100 pt-1 px-1">
                  <p v-if="invalid_property_size" class="error_validation_message_p_gardenhelp">
                    Please mark the garden on the map using the drawing tool
                  </p>
                  <GmapMap :center="map_center" :zoom="map_zoom" map-type-id="hybrid"
                    class="job-map-container-garden-help h-100" ref="gmap" style="min-height: 600px" :options="{
                      zoomControl: true,
                      mapTypeControl: false,
                      scaleControl: false,
                      streetViewControl: false,
                      rotateControl: false,
                      fullscreenControl: true,
                      disableDefaultUi: false,
                    }
                      ">
                    <GmapMarker v-if="job_position != null" :position="job_position" :clickable="false"
                      :draggable="false" />
                    <gmap-polygon :paths="polygon_points" :options="{
                      fillColor: '#0068B8',
                      fillOpacity: 0.5,
                      strokeColor: '#0068B8',
                      strokeWeight: 3,
                      editable: false,
                    }
                      " ref="polygon" v-if="selected_property_id != 'new'">
                    </gmap-polygon>
                  </GmapMap>
                  <!-- {{ paths }}
            <br />
            {{ edited }} -->
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>

        </b-card-body>
      </b-card>
      <!-- {{ is_company }} -->
      <!-- <b-row class="mb-4" >
        <b-col> -->
      <b-card no-body class="mt-4" v-if="user_type == 'user'">
        <b-card-body class="px-2">
          <SelectPayment :type="'add'" ref="selectPayment" :cards_list="cards_list"
            :payment_method_id.sync="payment_method_id" :invalid_payment_method="invalid_payment_method" />
        </b-card-body>
      </b-card>
      <!-- </b-col>
      </b-row> -->
      <!-- button -->
      <b-row class="justify-content-center justify-content-lg-right mt-3 mx-auto">
        <b-col xl="2" lg="3" sm="4" class="px-md-1 text-center">
          <b-button type="button" variant="garden-help-danger-light"
            class="btn-bumblebee btn-garden-help mb-1 w-100">Cancel</b-button>
        </b-col>
        <b-col xl="2" lg="3" sm="4" class="px-md-1 text-center">
          <b-button v-if="!is_loading && user_type == 'user' && find_contractor_id != null" type="submit"
            variant="garden-help-primary" class="btn-bumblebee btn-garden-help mb-1 w-100">
            Request A Quote
          </b-button>

          <b-button v-else-if="!is_loading && find_contractor_id == null" type="submit" variant="garden-help-primary"
            class="btn-bumblebee btn-garden-help mb-1 w-100">Save
            Job</b-button>

          <b-button v-else-if="is_loading" type="button" disabled variant="garden-help-primary"
            class="btn-bumblebee btn-garden-help mb-1 w-100">
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>


        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import { gmapApi } from "vue2-google-maps";
import PersonalData from "../customer/details_components/PersonalData.vue";
import PropertyDetails from "../customer/details_components/PropertyDetails.vue";
import ServiceDetails from "./details_components/ServiceDetails.vue";

import { uploadFiles } from "@/utils/upload-files.js";
import SelectPayment from "../components/SelectPayment.vue"
import InputRadio from "@/components/Inputs/InputRadio.vue";

import countries_list from '@/assets/country-list-data.json'


export default {
  name: "GardenHelpAddJob",
  components: { PersonalData, PropertyDetails, ServiceDetails, SelectPayment, InputRadio },
  data() {
    return {
      client_name: "GARDENHELP",
      user_type: null,
      user_id: null,
      google: gmapApi,

      map_zoom: 5,
      map_center: { lat: 53.364379779866695, lng: -6.8271807338634555 },
      job_position: null,
      edited: null,
      polygon: null,
      polygon_points: null,
      polygonOptions: {
        fillColor: "#0068B8",
        fillOpacity: 0.5,
        strokeColor: "#0068B8",
        strokeWeight: 3,
        editable: true,
      },
      drawingManager: null,
      invalid_property_size: false,

      //////////////// personal data
      perosnal_data_type: "add",
      first_name: "",
      invalid_first_name: false,
      last_name: "",
      invalid_last_name: false,
      email: "",
      invalid_email: false,
      invalid_correct_email: false,
      phone_number: "",
      invalid_phone_number: false,
      contact_through: null,
      selected_customer_id: 'new',
      customer_list: [],
      invalid_customer_id: false,
      ///////// property details
      property_data_type: "add",
      address: null,
      longitude: null,
      latitude: null,
      invalid_address: false,
      invalid_address_longitude: false,
      invalid_address_latitude: false,
      country: null,
      county: null,
      city: null,
      property_type: null,
      invalid_property_type: false,
      property_size: null,
      site_details: null,
      property_images: [],
      property_images_ids: [],
      invalid_images: false,
      selected_property_id: 'new',
      invalid_property_id: false,
      property_list: [],
      selected_property_images: [],
      //////// service details
      service: [],
      services_obj: [],
      service_options: [],
      invalid_service: false,
      first_time_service: null,
      last_service_date: null,
      booking_date: null,
      invalid_booking_date: false,
      short_description: null,
      more_details: null,


      cards_list: [
        { title: "New card", value: "new" }
      ],
      payment_method_id: null,
      invalid_payment_method: false,
      // paths: [
      //   [
      //     { lat: 1.38, lng: 103.8 },
      //     { lat: 1.38, lng: 103.81 },
      //     { lat: 1.39, lng: 103.81 },
      //     { lat: 1.39, lng: 103.8 },
      //   ],
      //   [
      //     { lat: 1.382, lng: 103.802 },
      //     { lat: 1.382, lng: 103.808 },
      //     { lat: 1.388, lng: 103.808 },
      //     { lat: 1.388, lng: 103.802 },
      //   ],
      // ],
      is_loading: false,
      user_type: localStorage.getItem('user_type'),

      find_contractor_id: null,
      job_id: null,


      yes_no_options: [
        { label: "Yes", value: 1 },
        { label: "No", value: 0 },
      ],
      assign_to_me: null,
      invalid_assign_to_me: false,

      country: null,
      country_code: null,

      staff_list: [],
      staff_id: null,
      invalid_staff_id: false,
      is_company: 0,

    };
  },
  mounted() {

    let user = JSON.parse(window.localStorage.getItem("user"));
    console.log("is company:", user.is_company)
    this.user_type = window.localStorage.getItem("user_type")
    this.user_id = user.id
    this.is_company = user.is_company != null ? user.is_company : 0
    this.google = gmapApi
    this.initMap();
    //
    this.getCustomerList()
    this.getPropertyList()
    this.getServicesList()
    console.log("=====", this.user_type)
    if (this.user_type == 'user') {
      this.getCustomerCardsList()
    }
    else if (this.user_type == 'operator') {
      this.country = user.country
      const country_data = countries_list.find(({ country }) => country === user.country);
      console.log(country_data)
      this.map_center = { lat: country_data.lat, lng: country_data.lng }
      this.map_zoom = 8;
      this.country_code = country_data.country_code // for phone field in personal data section
    }

    if (this.is_company == 1) {
      this.getStaffList()
    }

    this.user_type = localStorage.getItem('user_type')

    // console.log(this.$route.params.contractor_id == null)
    this.find_contractor_id = this.$route.params.contractor_id

  },
  watch: {
    latitude(newval, oldval) {
      if (newval == null) {
        this.job_position = null
      } else {
        this.map_center = { lat: this.latitude, lng: this.longitude };
        this.job_position = { lat: this.latitude, lng: this.longitude };
        this.map_zoom = 20;
      }
    },
    selected_customer_id(newval, oldval) {
      console.log("watch customer", newval, oldval)
      if (newval == 'new') {
        this.perosnal_data_type = "add"
        this.first_name = null
        this.last_name = null
        this.email = null
        this.phone_number = null
        this.contact_through = null
        this.property_list = [{ address: "New property", id: "new" }]
      } else {
        this.perosnal_data_type = "view"
        let selected_customer = this.customer_list.find(element => element.id == newval)
        // console.log(selected_customer)
        this.first_name = selected_customer.first_name
        this.last_name = selected_customer.last_name
        this.email = selected_customer.email
        this.phone_number = selected_customer.phone
        this.contact_through = selected_customer.contact_through
        this.property_list = selected_customer.properties.slice(0)
        this.property_list.push({ address: "New property", id: "new" })

        this.map_zoom = 9
        console.log(this.property_list[0])
        this.map_center = { lat: Number(this.property_list[0].lat), lng: Number(this.property_list[0].lon) }
      }
      this.selected_property_id = 'new'
    },
    selected_property_id(newval, oldval) {
      console.log("Watch property", newval, oldval)
      if (newval == 'new') {
        this.property_data_type = 'add'
        this.address = null
        this.latitude = null
        this.longitude = null
        this.property_type = null
        this.property_size = null
        this.site_details = null
        this.selected_property_images = []
        this.polygon_points = []
        this.drawingManager.setMap(this.$refs.gmap.$mapObject);
        $("#eraser-polygon").css("display", "block")
      } else {
        this.property_data_type = "view_add_job"
        let selected_customer = this.customer_list.find(element => element.id == this.selected_customer_id)
        let selected_property = selected_customer.properties.find(element => element.id == newval)
        this.address = selected_property.address
        this.latitude = Number(selected_property.lat)
        this.longitude = Number(selected_property.lon)
        this.property_type = selected_property.type
        this.property_size = selected_property.size
        this.site_details = selected_property.site_details
        this.selected_property_images = selected_property.media
        // console.log(selected_property.map_points.points)

        this.polygon_points = []
        for (let i = 0; i < selected_property.map_points.points.length; i++) {
          this.polygon_points.push({
            lat: Number(selected_property.map_points.points[i].lat),
            lng: Number(selected_property.map_points.points[i].lng)
          })
        }
        this.map_center = {
          lat: Number(selected_property.map_points.points[0].lat),
          lng: Number(selected_property.map_points.points[0].lng)
        }
        this.map_zoom = 18
        this.drawingManager.setMap(null);
        $("#eraser-polygon").css("display", "none")

      }
    },
    service(newval) {
      // console.log("Service", newval)
      // console.log(this.service_options)
      this.services_obj = this.service_options.filter(service => newval.includes(service.id))
      // console.log(this.services_obj)
    },
    assign_to_me(newval, oldval) {
      this.staff_id = null
    }
  },
  methods: {
    uploadFiles,
    initMap() {
      let temp = this;

      setTimeout(function () {
        if (this.google) {

          console.log(temp.$refs.gmap.$mapObject);
          temp.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_LEFT,
              drawingModes: [google.maps.drawing.OverlayType.POLYGON],
            },
            markerOptions: {
              icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
            },
            polygonOptions: temp.polygonOptions
          });
          temp.drawingManager.setMap(temp.$refs.gmap.$mapObject);
          google.maps.event.addListener(
            temp.drawingManager,
            "overlaycomplete",
            function (event) {
              // Get overlay paths
              console.log(event);
              let paths = event.overlay.getPath().getArray();
              console.log(paths);
              var newShape = event.overlay;
              newShape.type = event.type;
              temp.polygon = newShape; // Remove overlay from map
              // event.overlay.setMap(null);
              console.log(temp.calculatePolygonSize(event.overlay.getPath()));

              // Disable drawingManager
              temp.drawingManager.setDrawingMode(null);

              // Create Polygon
              // temp.savePolygon(paths);
              console.log("----------------------------------------");
              // overlayDragListener(event.overlay);
              let overlay = event.overlay;
              google.maps.event.addListener(
                overlay.getPath(),
                "set_at",
                function (event) {
                  // $('#vertices').val(overlay.getPath().getArray());
                  console.log(overlay.getPath().getArray());
                  console.log(temp.calculatePolygonSize(overlay.getPath()));
                }
              );
              google.maps.event.addListener(
                overlay.getPath(),
                "insert_at",
                function (event) {
                  // $('#vertices').val(overlay.getPath().getArray());
                  console.log(overlay.getPath().getArray());
                  console.log(temp.calculatePolygonSize(overlay.getPath()));
                }
              );
            }
          );
          google.maps.event.addListener(
            temp.drawingManager,
            "polygoncomplete",
            function (polygon) {
              console.log(polygon);
            }
          );

          google.maps.event.addListener(
            temp.drawingManager,
            "drawingmode_changed",
            function () {
              if (temp.drawingManager.getDrawingMode() != null) {
                temp.polygon.setMap(null);
                temp.polygon = null;
              }
            }
          );

          google.maps.event.addListener(
            temp.drawingManager,
            "error",
            function (error) {
              console.error(error);
              console.error('error');
            }
          );

          // delete polygon
          //Add a custome control button
          let controlDiv = document.createElement("div");
          // Set CSS for the control border.
          const controlUI = document.createElement("div");
          controlUI.id = "eraser-polygon"
          controlUI.style.backgroundColor = "#fff";
          controlUI.style.border = "2px solid #fff";
          controlUI.style.borderRadius = "3px";
          controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
          controlUI.style.cursor = "pointer";
          controlUI.style.margin = "5px -4px";
          controlUI.style.height = "28px";
          controlUI.style.textAlign = "center";
          // controlUI.title = "Click to recenter the map";
          controlDiv.appendChild(controlUI);

          const controlText = document.createElement("div");
          controlText.style.color = "rgb(25,25,25)";
          controlText.style.fontFamily = "Roboto,Arial,sans-serif";
          controlText.style.fontSize = "16px";
          controlText.style.lineHeight = "16px";
          controlText.style.padding = "4px";
          controlText.innerHTML = '<i class="fas fa-eraser"></i>';

          controlUI.appendChild(controlText);
          // Setup the click event listeners: simply set the map to Chicago.
          controlUI.addEventListener("click", () => temp.deleteSelectedShape());

          temp.$refs.gmap.$mapObject.controls[
            google.maps.ControlPosition.TOP_LEFT
          ].push(controlDiv);
        } else {
          console.error("Google Maps API not loaded yet");

          temp.$fire({
            // title: "Title",
            text: "A network issue caused the map to not function correctly, please reload the page to try again",
            type: "error",
            customClass: {
              container: "swal-alert-garden-help",
              confirmButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
              cancelButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
            },
            // timer: 3000,
          }).then((r) => {
            temp.$router.go();

          });
          //
        }
      }, 1000);
    },
    getCustomerList() {
      axios
        .get("/common/contacts", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.customer_list = response.data;

          if (this.user_type != 'user') {
            this.customer_list.push({ name: "New customer", id: "new" })
          }
          else {
            this.selected_customer_id = response.data[0].id
          }
        });
    },
    getPropertyList() {
      this.property_list = [{ address: "New property", id: "new" }]
    },
    getServicesList() {
      axios
        .get("/services/list", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
          },
        })
        .then((response) => {
          console.log(response);
          this.service_options = response.data;
          console.log(Object.keys(this.$route.query).length)
          if (Object.keys(this.$route.query).length != 0) {
            let selected_services = this.$route.query.services.split(',')
            this.service = []
            for (let i = 0; i < selected_services.length; i++) {
              this.service.push(Number(selected_services[i]))
            }
          }
        });
    },
    getStaffList() {
      console.log("in get staff list", this.user_id)
      axios
        .post("/operator/contractor/list-staff", {}, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response)
          console.log(response.data)
          console.log(response)
          this.staff_list = response.data.data;

        });
    },
    getCustomerCardsList() {
      axios
        .get("payment/pm/get-user-pms", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log("---- cards")
          console.log(response);
          this.cards_list = []
          for (let i = 0; i < response.data.payment_methods.length; i++) {
            let item = response.data.payment_methods[i]
            this.cards_list.push({ title: "**** **** **** " + item.last_four, value: item.id })
          }
          this.cards_list.push({ title: "New card", value: "new" })


        });
    },
    deleteSelectedShape() {
      this.polygon.setMap(null);
      this.polygon = null;
    },
    calculatePolygonSize(path) {
      let size = google.maps.geometry.spherical.computeArea(path);
      console.log("size: " + size + " meters");
      console.log(path);
      this.property_size = Math.round(size * 100) / 100;
      let path_arr = path.getArray(),
        points = [];
      for (let i = 0; i < path_arr.length; i++) {
        console.log("      ", path_arr[i].lat(), path_arr[i].lng());
        points.push({ lat: path_arr[i].lat(), lng: path_arr[i].lng() });
      }
      this.map_points = { points: points };
      console.log(points);
      console.log(this.map_points);

      return size;
    },
    async onSubmit() {
      console.log("on submit add job", this.user_type, this.user_id)
      console.log(this.$refs)

      console.log("customer: ", this.selected_customer_id, this.customer_list)
      console.log(this.first_name, ",", this.last_name, ",", this.email, ",", this.phone_number, ",", this.contact_through)
      console.log("property: ", this.selected_property_id, this.property_list)
      console.log(this.address, ",", this.longitude, ",", this.latitude)
      console.log(this.country, this.city, this.county)
      console.log(this.property_type, ",", this.property_size, ",", this.site_details)
      console.log(this.property_images, ",", this.property_images_ids)
      console.log("service:", this.service)
      console.log(this.first_time_service, ",", this.last_service_date, ",", this.booking_date, ",", this.short_description, ",", this.more_details)
      console.log("is company:", this.is_company)
      console.log(this.assign_to_me, this.invalid_assign_to_me)
      console.log(this.staff_id, this.invalid_staff_id)

      this.is_loading = true
      this.checkValidation()

      if (!this.invalid_customer_id && !this.invalid_phone_number && !this.invalid_property_id && !this.invalid_property_type &&
        !this.invalid_address && !this.invalid_address_latitude && !this.invalid_address_longitude && !this.invalid_property_size &&
        !this.invalid_images && !this.invalid_service && !this.invalid_booking_date && !this.invalid_payment_method &&
        !this.invalid_assign_to_me && !this.invalid_staff_id) {

        if (this.payment_method_id == 'new') {
          let saved_card = await this.$refs.selectPayment.$refs.stripeComponentUserRef.purchase()
          console.log("after save card and before save job request", saved_card)
          if (!saved_card) {
            this.is_loading = false
            return;
          }
        }

        let requestData = {
          client: this.client_name,
          owner_id: this.user_id,
          owner_type: this.user_type,

          // "contact": {
          //   "first_name": this.first_name,
          //   "last_name": this.last_name,
          //   "phone": this.phone_number,
          //   "email": this.email,
          //   contact_through: this.contact_through
          // },

          "location": this.address,
          "location_lat": this.latitude,
          "location_lang": this.longitude,

          "country": this.country,
          "county": this.county,
          "city": this.city,

          // "property": {
          //   "type": this.property_type,
          //   "size": this.property_size,
          //   "size_unit": "m2",
          //   "site_details": this.site_details.toString(),
          //   "map_points": this.map_points,
          //   "images": this.property_images_ids,
          //   // location for property?!!
          //   // "location": this.address,
          //   // "location_lat": this.latitude,
          //   // "location_lang": this.longitude,
          // },

          "order_details": {
            "service_types": this.service.toString(),
            "first_time": this.first_time_service,
            "last_service_date": this.last_service_date,
            "booking_date": this.booking_date
          },

          "description": this.short_description,
          note: this.more_details
        };

        if (this.selected_property_id == 'new') {
          if (this.property_images != null && this.property_images.length > 0) {
            this.property_images_ids = await this.uploadFiles(
              this.client_name,
              this.property_images,
              null
            );
          }
          console.log("after upload images")
          console.log(this.property_images_ids)

          requestData.property = {
            "type": this.property_type,
            "size": this.property_size,
            "size_unit": "m2",
            "site_details": this.site_details != null ? this.site_details.toString() : '',
            "map_points": this.map_points,
            "images": this.property_images_ids,
          }
        } else {
          requestData.property = {
            "property_id": this.selected_property_id
          }
        }

        if (this.selected_customer_id != 'new') {
          requestData.contact = {
            "contact_id": this.selected_customer_id
          }
          if (this.selected_property_id != 'new') {
            console.log("================= defined customer and property", this.selected_customer_id, this.selected_property_id)
            console.log(requestData)

            console.log(requestData)
          } else {
          }
        } else {
          requestData.contact = {
            "first_name": this.first_name,
            "last_name": this.last_name,
            "phone": this.phone_number,
            "email": this.email,
            contact_through: this.contact_through
          }
        }
        if (this.assign_to_me == 1) {
          requestData.status = 'assigned'
          requestData.operator_id = this.user_id
        }
        else if (this.is_company === 1 && this.assign_to_me == 0) {
          requestData.status = 'accepted'
          requestData.operator_id = this.staff_id
        }

        if (this.payment_method_id != null && this.payment_method_id != 'new') {
          requestData.payment_method_id = this.payment_method_id
        }
        console.log(requestData)
        this.sendAddJobRequest(requestData)
      } else {
        this.is_loading = false
      }
    },
    checkValidation() {
      if (this.selected_customer_id == null || this.selected_customer_id == '') {
        this.invalid_customer_id = true
      } else {
        this.invalid_customer_id = false
      }

      if (this.selected_property_id == null || this.selected_property_id == '') {
        this.invalid_property_id = true
      } else {
        this.invalid_property_id = false
      }

      if (this.phone_number == null || this.phone_number == '') {
        this.invalid_phone_number = true
      } else {
        this.invalid_phone_number = false
      }

      console.log("address")
      console.log(this.address)
      if (this.address == null || this.address == '') {
        this.invalid_address = true
      } else {
        this.invalid_address = false
        if (this.latitude == null || this.latitude == '') {
          this.invalid_address_latitude = true
        } else {
          this.invalid_address_latitude = false
        }
        if (this.longitude == null || this.longitude == '') {
          this.invalid_address_longitude = true
        } else {
          this.invalid_address_longitude = false
        }
      }


      // if (this.selected_property_id == 'new'
      //   && (this.property_images == null || this.property_images.length == 0)) {
      //   this.invalid_images = true
      // } else {
      //   this.invalid_images = false
      // }
      console.log(this.selected_property_id)
      console.log(this.property_size == null || this.property_size == '' || this.property_size == 0)
      console.log(this.property_size, this.property_size == null, this.property_size == '', this.property_size == 0)
      if (this.selected_property_id == 'new'
        && (this.property_size == null || this.property_size == '' || this.property_size == 0)) {
        this.invalid_property_size = true
      } else {
        this.invalid_property_size = false
      }
      if (this.selected_property_id == 'new'
        && (this.property_type == null || this.property_type == '')) {
        this.invalid_property_type = true
      } else {
        this.invalid_property_type = false
      }

      if (this.service == null || this.service.length == 0) {
        this.invalid_service = true
      } else {
        this.invalid_service = false
      }
      if (this.booking_date == null || this.booking_date == '') {
        this.invalid_booking_date = true
      } else {
        this.invalid_booking_date = false
      }

      if (this.is_company === 1) {
        if (this.assign_to_me == null || this.assign_to_me == '') {
          this.invalid_assign_to_me = true
        } else {
          this.invalid_assign_to_me = false
        }

        if (this.assign_to_me == 0) {
          if (this.staff_id == null || this.staff_id == '') {
            this.invalid_staff_id = true
          } else {
            this.invalid_staff_id = false
          }
        }
      }
      // if (this.payment_method_id == 'new') {
      //   this.invalid_payment_method = true
      // } else {
      //   this.invalid_payment_method = false
      // }
    },
    sendAddJobRequest(requestData) {

      console.log(requestData)
      axios
        .post("jobs/jobs", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.job_id);
          this.job_id = response.data.job_id
          if (this.find_contractor_id != null) {
            console.log("before save quote request", this.job_id)
            this.sendRequestQuote()

          } else {
            this.$fire({
              // title: "Title",
              text: "Thank you! Your job has been created successfully. To process it, please download the mobile app and continue ",
              type: "success",
              customClass: {
                container: "swal-alert-garden-help",
                confirmButton:
                  "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                cancelButton:
                  "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
              },
              // timer: 3000,
            }).then((r) => {
              // console.log(r.value);
              this.is_loading = false;
              // this.$router.go();
              if (this.user_type == 'admin') {
                this.$router.push({ name: "GardenHelpAllJobsAdmin" });
              } else if (this.user_type == 'user') {
                this.$router.push({ name: "GardenHelpJobsTable" });
              } else if (this.user_type == 'operator') {
                if ((this.assign_to_me == 1 && this.is_company == 0) || (this.assign_to_me && this.is_company == 1)) {
                  this.$router.push({ name: "GardenHelpCreateQuoteIndex", params: { id: this.job_id, send_email: 't' } });
                } else {
                  this.$router.push({ name: "GardenHelpMyJobs" });
                }
              } else {
                this.$router.go();
              }
            });
          }

        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              container: "swal-alert-garden-help",
              confirmButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
              cancelButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendRequestQuote() {
      console.log("send request quote", this.service, this.job_id)
      let quote_items = []
      for (let service of this.services_obj) {
        quote_items.push({
          type: "service",
          name: service.name,
          price_str: '€0',
          price: 0,
          description: null
        })
      }
      let requestData = {
        client: this.client_name,
        "status": "request",
        "subtotal": 0,
        "vat": 0,
        "total": 0,
        "currency": "eur",
        "model_type": "Job",
        "model_id": this.job_id,
        "client": "GARDENHELP",
        "invoice_items": quote_items,
        requested_from_id: this.find_contractor_id,
        requested_from_type: "operator"
      }


      console.log(requestData)
      axios
        .post("payment/invoices", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Quote requested successfully ",
            type: "success",
            customClass: {
              container: "swal-alert-garden-help",
              confirmButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
              cancelButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
            // this.$router.go();
            this.$router.push({ name: "GardenHelpJobsTable" });
          });
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              container: "swal-alert-garden-help",
              confirmButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
              cancelButton:
                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    }
  },
};
</script>

<style >
.gmnoprint div button {
  margin-right: 4px !important;
  border-radius: 3px !important;
}
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/AddJob.vue